import { useSelector } from "react-redux";
import StringToDateTime from "../../util/StringToDateTime";
import AvatarRound from "../AvatarRound";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

function TabLog({ data }) {

    const stateUserList = useSelector((state) => state.userList);

    return (
        <>
            {
                [...data].sort((a, b) => b.ID - a.ID).map((item, index) => (
                    <div key={item.ID} className={"list_item row mt-10"} >
                        <div className="col-md-4">
                            <div>
                                {stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 ?
                                    (
                                        <div className="d-flex">
                                            <AvatarRound img={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small} width={20} name={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User} />
                                            <div className="ml-5">{stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User}</div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div className="d-flex">
                                            <AvatarRound img={null} width={20} name='Не найден' />
                                            <div className="ml-5">Не найден</div>
                                        </div>
                                    )}
                            </div>
                            <small><FontAwesomeIcon icon={faCalendar} className="mr-5" />{StringToDateTime(item.Date_Add)}</small>
                        </div>
                        <div className="col-md-4">
                            {item.Name}
                        </div>
                        <div className="col-md-4" >
                            <div>
                                {item.Description}
                            </div>
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default TabLog;